import type {ResultsScope} from '../../shared/ballotTypes';
import {statLine} from '../../shared/format';

export type PreviewRow = {
    place: number;
    name: string;
    photos: (string | null)[];
    names: string[];
    stat: string | null;
    heads: number;
    bar: 'none' | 'fill' | 'heads';
    fill: number;
};

export type PreviewOption = {
    title: string;
    people: {name: string; photoUrl: string | null}[];
};

// Illustrative counts per position; the first option is always the sample winner.
const COUNTS = [19, 14, 11, 8, 5, 3, 2];
const countAt = (index: number): number => COUNTS[index] ?? 1;

export const previewModel = (
    options: PreviewOption[],
    settings: {scope: ResultsScope; showCount: boolean; showShare: boolean; showVoters: boolean},
): {winner: PreviewRow | null; rows: PreviewRow[]} => {
    const named = options.filter((o) => o.title.trim() !== '');
    if (named.length < 2) {
        return {winner: null, rows: []};
    }
    const total = named.reduce((sum, _o, index) => sum + countAt(index), 0);
    const maxPlace = {winner: 1, top3: 3, all: named.length}[settings.scope];
    const bar = settings.showVoters
        ? 'heads'
        : settings.showCount || settings.showShare
          ? 'fill'
          : 'none';
    const toRow = (o: PreviewOption, index: number): PreviewRow => {
        const count = countAt(index);
        return {
            place: index + 1,
            name: o.title.trim(),
            photos: o.people.map((p) => p.photoUrl),
            names: o.people.map((p) => p.name),
            stat: statLine({
                count: settings.showCount ? count : null,
                share: settings.showShare ? count / total : null,
            }),
            heads: settings.showVoters ? Math.ceil(count / 3) : 0,
            bar,
            fill: count / COUNTS[0],
        };
    };
    const all = named.map(toRow);
    return {winner: all[0], rows: all.slice(1, maxPlace)};
};
